var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-link btn-circle btn-add",on:{"click":function (e) { e.preventDefault(); _vm.onClick(e); }}},[_c('i',{staticClass:"fa fa-plus"})])}
var staticRenderFns = []

export { render, staticRenderFns }